<!-- Loader global — affiché tant qu'au moins une requête HTTP est en cours -->
<div class="arp-loader" *ngIf="loaderService.isLoading()" role="status" aria-live="polite">
  <div class="arp-loader__inner">
    <!-- Logo central pulsé -->
    <div class="arp-loader__logo">
      <img src="/logo-header.png" alt="ARP" onerror="this.style.display='none'" />
    </div>

    <!-- Anneau qui tourne -->
    <svg class="arp-loader__ring" viewBox="0 0 50 50" aria-hidden="true">
      <circle cx="25" cy="25" r="20" fill="none" stroke-width="3"></circle>
    </svg>
 
  </div>
</div>
